// extracted by mini-css-extract-plugin
export default {"modalContainer":"ThankYouWindow_modalContainer__+yb9m","mainText":"ThankYouWindow_mainText__NA68-","secondTetx":"ThankYouWindow_secondTetx__ibfRg"};